module.exports = new __parcel__URL__("mining_return_home_button.1409f244.png").toString();